export default __webpack_public_path__ + "GreycliffCF-Bold.woff2";